import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment, SourceApps } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { SignInButton } from '../presentationalComponents/SignInButton';
import {
  setUserIsSigningIntoClientApp,
  setAuthInfoForTeams,
} from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchRedirectForSignInLink, dispatchSignInUser, dispatchUserInfoFetch } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState) => {
  return {
    redirectForSignInLink:
      state.ContactState.ModalitySectionState.redirectForSignInLink,
    isClientApp:
      state.GlobalState.environment === Environment.nonAgavePane ||
      state.GlobalState.sourceApp === SourceApps.Teams ||
      state.GlobalState.sourceApp === SourceApps.Teams2 ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin2,
    clientTokenInfoModel:
      state.ContactState.ModalitySectionState.clientTokenRetrievalInfoModel,
    sourceApp: state.GlobalState.sourceApp,
    namespace: state.GlobalState.namespace,
    isTeams:
      state.GlobalState.sourceApp === SourceApps.Teams ||
      state.GlobalState.sourceApp === SourceApps.Teams2 ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin2,
  };
};

const mapDispatchToProps = {
  dispatchRedirectForSignInLink,
  dispatchSignInUser,
  setUserIsSigningIntoClientApp,
  setAuthInfoForTeams,
  dispatchUserInfoFetch,
};

export const SignInButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SignInButton, getContactUsStyles));
